































import { IPRCFilter } from "@/models";
import RateChangesModule from "@/store/modules/rate-changes";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const rateChanges = namespace(RateChangesModule.name);

@Component({
  name: "UnitArea"
})
export default class UnitArea extends Vue {
  // ===== Store ===== //
  @rateChanges.Action private applyFilter!: (filter: IPRCFilter) => void;
  // ===== Props ===== //
  @Prop(Number) private readonly filter!: number;
  // ===== Data ===== //
  private chipText = "";
  private queryString = "";
  private unitAreaMin = "";
  private unitAreaMax = "";
  // ===== Methods ===== //
  public generateQuery(): void {
    if (this.unitAreaMin && !this.unitAreaMax) {
      this.chipText = `Unit Area minimum is >= ${this.unitAreaMin} sq. ft.`;
      this.queryString = `facility_units_area[gte]=${this.unitAreaMin}`;
    } else if (this.unitAreaMax && !this.unitAreaMin) {
      this.chipText = `Unit Area maximum is >= ${this.unitAreaMax} sq. ft.`;
      this.queryString = `facility_units_area[lte]=${this.unitAreaMax}`;
    } else {
      this.chipText = `Unit Area minimum is >= ${this.unitAreaMin} sq. ft. & maximum is <= ${this.unitAreaMax} sq. ft.`;
      this.queryString = `facility_units_area[gte]=${this.unitAreaMin}&facility_units_area[lte]=${this.unitAreaMax}`;
    }
  }
  @Watch("unitAreaParameter", { deep: true })
  public async handleSelectedUnitArea(unitAreaParameter: IPRCFilter): Promise<void> {
    await this.generateQuery();
    this.applyFilter(unitAreaParameter);
  }
  // ===== Computed ===== //
  get unitAreaOperator(): string {
    if (this.unitAreaMin && !this.unitAreaMax) {
      return "[gte]";
    } else if (this.unitAreaMax && !this.unitAreaMin) {
      return "[lte]";
    } else {
      return "[lte][gte]";
    }
  }
  get unitAreaParameter(): IPRCFilter {
    return {
      id: this.filter,
      chipText: this.chipText,
      operator: this.unitAreaOperator,
      value: `${this.unitAreaMin}, ${this.unitAreaMax}`,
      query: this.queryString
    };
  }
}
